import { render } from "./PlaysContent.vue?vue&type=template&id=299dbee7&ts=true"
import script from "./PlaysContent.vue?vue&type=script&lang=ts"
export * from "./PlaysContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Admin/Queries/PlaysContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "299dbee7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('299dbee7', __exports__)) {
    api.reload('299dbee7', __exports__)
  }
  
  module.hot.accept("./PlaysContent.vue?vue&type=template&id=299dbee7&ts=true", () => {
    api.rerender('299dbee7', render)
  })

}


export default __exports__